'use client';

import { useEffect } from 'react';

interface ScrollObserverProps {
	targetSelector: string;
}

function ScrollObserver({ targetSelector }: ScrollObserverProps) {
	// Effects
	useEffect(() => {
		const targetElement = document.querySelector(targetSelector);
		if (!targetElement) return;

		const handleScroll = () => {
			if (window.scrollY > 10) {
				targetElement.setAttribute('data-scrolled', 'true');
			} else {
				targetElement.removeAttribute('data-scrolled');
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [targetSelector]);

	return null;
}

export default ScrollObserver;
